var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["carousel-slider/instructional-text-zoom.j2"] = require( "carousel-slider/instructional-text-zoom.j2" );
dependencies["carousel-slider/carousel-slides-lazy.j2"] = require( "carousel-slider/carousel-slides-lazy.j2" );
dependencies["carousel-slider/carousel-zoom-image-arrows.j2"] = require( "carousel-slider/carousel-zoom-image-arrows.j2" );
dependencies["modal/modal-close.j2"] = require( "modal/modal-close.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/carousel-slider/carousel-zoom-image-container.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "\n";
var t_1;
t_1 = "--shadow-zoom";
frame.set("shadowZoomClass", t_1, true);
if(frame.topLevel) {
context.setVariable("shadowZoomClass", t_1);
}
if(frame.topLevel) {
context.addExport("shadowZoomClass", t_1);
}
output += "\n";
var t_2;
t_2 = "$redesign-zoom-5x$";
frame.set("preset", t_2, true);
if(frame.topLevel) {
context.setVariable("preset", t_2);
}
if(frame.topLevel) {
context.addExport("preset", t_2);
}
output += "\n";
var t_3;
t_3 = 2175;
frame.set("imageHeight", t_3, true);
if(frame.topLevel) {
context.setVariable("imageHeight", t_3);
}
if(frame.topLevel) {
context.addExport("imageHeight", t_3);
}
output += "\n\n<div class=\"o-carousel o-carousel--product-image js-shadow-zoom--product-image\">\n\n\t";
env.getTemplate("carousel-slider/instructional-text-zoom.j2", false, "product/templates/carousel-slider/carousel-zoom-image-container.j2", null, function(t_6,t_4) {
if(t_6) { cb(t_6); return; }
t_4.render(context.getVariables(), frame, function(t_7,t_5) {
if(t_7) { cb(t_7); return; }
output += t_5
output += "\n\t\n    ";
env.getTemplate("carousel-slider/carousel-slides-lazy.j2", false, "product/templates/carousel-slider/carousel-zoom-image-container.j2", null, function(t_10,t_8) {
if(t_10) { cb(t_10); return; }
t_8.render(context.getVariables(), frame, function(t_11,t_9) {
if(t_11) { cb(t_11); return; }
output += t_9
output += "\n\n</div>\n\n";
output += "\n";
env.getTemplate("carousel-slider/carousel-zoom-image-arrows.j2", false, "product/templates/carousel-slider/carousel-zoom-image-container.j2", null, function(t_14,t_12) {
if(t_14) { cb(t_14); return; }
t_12.render(context.getVariables(), frame, function(t_15,t_13) {
if(t_15) { cb(t_15); return; }
output += t_13
output += "\n\n";
output += "\n<div class=\"o-shadow-zoom__close-zoom js-shadow-zoom__close-zoom\" href data-qa-zoom-close-x=\"\">\n\n    ";
env.getTemplate("modal/modal-close.j2", false, "product/templates/carousel-slider/carousel-zoom-image-container.j2", null, function(t_18,t_16) {
if(t_18) { cb(t_18); return; }
t_16.render(context.getVariables(), frame, function(t_19,t_17) {
if(t_19) { cb(t_19); return; }
output += t_17
output += "\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/carousel-slider/carousel-zoom-image-container.j2"] , dependencies)